/**
 * The chat assistant's identity (issue #78).
 *
 * Kept in one module because the name has to agree in three places that are
 * otherwise unrelated: the panel header, the static opening greeting, and the
 * server's system prompt. A customer who is greeted by one name and then told
 * a different one when they ask "who am I talking to?" learns immediately that
 * nobody is really there, which is the opposite of the point.
 *
 * The server can't import this file, so `server/src/services/chat/
 * systemPrompt.ts` carries its own copy of the name with a comment pointing
 * back here - change both together.
 *
 * On the photograph: this is a stock photo of someone who does not work here,
 * presented under a name that is not theirs, so it does assert that a specific
 * real person is on the other end. That was a deliberate product decision
 * (Rupert, 2026-09), not a default - worth knowing it is one, because the
 * safest version of it is a stock library image that ships with a model
 * release. Unsplash does not provide one.
 */

/** One name, used everywhere. Changing this line renames the assistant. */
export const ASSISTANT_NAME = 'Ella'

/**
 * Served from client/public - the site's convention for static assets is an
 * absolute path, never an ES import (see DirectoryModeLogo.tsx, Home.tsx).
 *
 * Local rather than remote: the homepage testimonials pull their avatars from
 * DiceBear's API, which is fine for content far down a marketing page but not
 * for a chat header that has to render instantly and would otherwise depend on
 * a third party being up.
 *
 * 128px square, which is 2x for the 36px header and well over 2x for the 28px
 * message avatars. The original download was a 7952x5304, 2.7 MB press-quality
 * file - 600x every other asset on the site, fetched on every chat open, much
 * of it by someone on mobile data in an emergency. Resized with the same sharp
 * settings scripts/lib/imagePipeline.ts uses for plumber logos. If the picture
 * is ever swapped, resize it the same way rather than dropping the original in.
 *
 * Photo: Troy Spoelma, via Unsplash.
 */
export const ASSISTANT_AVATAR_SRC = '/assistant-avatar.jpg'
